import React from 'react';
import Avatar from '@atlaskit/avatar';
import type { BillingAdminPersonProps } from './types';
import { DefaultLozenge } from '../../copyable-text';
import './billing-admin.scss';

const getPartnerAdmin = (
  picture: string,
  fullName: string | null | undefined,
  email: string | null | undefined,
  version: number | undefined
) => (
  <div className={version === 2 ? 'billing-admin-person-container-v2' : 'billing-admin-person-container'}>
    <Avatar src={picture} size={version === 2 ? 'medium' : 'large'} />
    <div className="billing-admin-person">
      <span>
        {fullName} <DefaultLozenge label="PARTNER ADMIN" />
      </span>
      <span className="billing-admin-person-email">{email}</span>
    </div>
  </div>
);

const getBillingAdmin = (
  picture: string,
  fullName: string | null | undefined,
  email: string | null | undefined,
  version: number | undefined
) => (
  <div className={version === 2 ? 'billing-admin-person-container-v2' : 'billing-admin-person-container'}>
    <Avatar src={picture} size={version === 2 ? 'medium' : 'large'} />
    <div className="billing-admin-person">
      <span>{fullName}</span>
      <span data-testid={`billing-admin-email-${email}`} className="billing-admin-person-email">
        {email}
      </span>
    </div>
  </div>
);

const BillingAdminPerson = ({ fullName, email, isPartnerAdmin, picture, version }: BillingAdminPersonProps) => {
  return isPartnerAdmin
    ? getPartnerAdmin(picture, fullName, email, version)
    : getBillingAdmin(picture, fullName, email, version);
};

export default BillingAdminPerson;
